import { Component, inject, input, output, signal } from '@angular/core';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCard } from '@angular/material/card';
import { UserRolesIds } from '@models';
import { Store } from '@ngrx/store';
import { AuthSelectors } from '@ngrx-store';

import { DeviceActionListComponent } from '../device-action-list';
import { RemoteActionListComponent } from '../remote-action-list/remote-action-list.component';

enum Tabs {
  ACTIONS = 'actions',
  REMOTE = 'remote',
}

@Component({
  imports: [MatCard, MatButtonToggleModule, RemoteActionListComponent, DeviceActionListComponent],
  selector: 'avs-actions-menu',
  templateUrl: './actions-menu.component.html',
})
export class ActionsMenuComponent {
  deviceId = input.required<string>();
  twoWayCommunication = input(false);
  editable = input(true);
  remoteActionsChanged = output();

  protected tab = signal(Tabs.ACTIONS);
  protected readonly eTabs = Tabs;
  protected isBasicUser = signal(false);
  private store = inject(Store);

  constructor() {
    this.store
      .select(AuthSelectors.userRole)
      .subscribe(roleId => {
        const isBasicUser = roleId === UserRolesIds.ReadOnly;

        this.isBasicUser.set(isBasicUser);
      });
  }
}
